import React from "react";
import { NakiMobileHomeSectionListTemplate } from "themes/administration/naki-mobile/pages";
import { NakiMobileEmbeddedHomeSectionListViewStore } from "administration/naki-mobile/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new NakiMobileEmbeddedHomeSectionListViewStore(rootStore, componentProps),
    "nakiMobileHomeSectionListViewStore"
)
class NakiMobileEmbeddedHomeSectionList extends React.Component {
    render() {
        return <NakiMobileHomeSectionListTemplate {...this.props} />;
    }
}

export default NakiMobileEmbeddedHomeSectionList;
